import classNames from "../utils/classNames";

const Select = ({
  id = "",
  name = "",
  className = "",
  placeholder = "",
  value = null,
  onChange,
  labelText = "",
  hasErrors = false,
  options = [],
  appendText = "",
  keyName = null,
  ...rest
}) => {
  const baseWrapperStyles = classNames(
    "flex items-center border rounded-lg",
    !hasErrors &&
      "border-[#afb6b9] focus-within:border-transparent focus-within:ring-2 focus-within:ring-primary",
    hasErrors && !appendText && "border-transparent ring-2 ring-red-500",
    hasErrors && appendText && "border-transparent ring-2 ring-red-500",
  );

  const baseSelectStyles = classNames(
    "w-full border-0 p-3 focus:ring-0 ring-inset placeholder-[#afb6b9] bg-transparent appearance-none",
    appendText ? "rounded-l-lg" : "rounded-lg",
  );

  return (
    <div>
      {labelText && (
        <label
          htmlFor={id}
          className={`block text-md font-bold leading-[1.5] mb-1 ${
            hasErrors ? "text-red-500" : ""
          }`}
        >
          {labelText}
        </label>
      )}
      <div className={baseWrapperStyles}>
        <div className="relative flex-1">
          <select
            id={id}
            name={name}
            className={`${baseSelectStyles} ${className}`}
            value={value}
            onChange={onChange}
            {...rest}
          >
            <option value="">{placeholder || "Select an option"}</option>
            {options.map((option) => (
              <option
                key={keyName ? option[keyName] : option.value}
                value={option.value}
              >
                {option.label}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
            <svg
              className="h-4 w-4 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
        {appendText && (
          <span className="text-md px-4 py-1 border-l border-[#afb6b9] select-none">
            {appendText}
          </span>
        )}
      </div>
    </div>
  );
};

export default Select;
